import React from 'react';
import { PageHeaderProps } from 'antd';

import {
  StyledPageHeader,
} from './style';

const SectionPageHeader = (props: PageHeaderProps): JSX.Element => (
  <StyledPageHeader {...props} />
);

export default SectionPageHeader;
